import { debug } from "util";
import { fail } from "assert";

cb.define([], function () {
  var PC_pc_customer_VM_Extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
      var self = this;
      const diffpcCustomerType = () => {
        let pcCustomerType = viewmodel.get("pcCustomerType").getValue();
        let _value = pcCustomerType.includes("1");
        [
          "userName",
          "userMobile", // 手机号前缀
          "userCode",
          "userEmail",
          "mobilePreno", // 手机号
        ].forEach((element) => {
          viewmodel.get(element).setState("bIsNull", !_value)
        });
      }
      viewmodel.on('afterLoadData', function () {
        diffpcCustomerType()
        var strCode = viewmodel.get("userCode").getValue();
        if (strCode !== "" && strCode != null) {
          if (strCode.indexOf("@" + cb.rest.AppContext.tenant.alias) > 0) {
            viewmodel.get("userCode").setValue(strCode.replace("@" + cb.rest.AppContext.tenant.alias, ""))
          }
        }
      });

      viewmodel.on('beforeDeleteRow', (args) => {
        if (args.params.childrenField === "custApplyRangeInfos") {
          let _data = viewmodel.get('custApplyRangeInfos').getRow(args.params.params.index)
          if (_data.isCreator) {
            cb.utils.alert('创建组织不能删除', 'warning');
            return false
          }
        }
      })
      // 客户身份类型 值改变
      viewmodel.get('pcCustomerType').on('afterValueChange', () => diffpcCustomerType())
      viewmodel.on('beforeSave', function (args) {
        if (self.savecheck(args, viewmodel) === false) {
          return false;
        }
      });
      viewmodel.on('beforeSaveandadd', function (args) {
        if (args.params.cAction === "saveandadd") {
          if (self.savecheck(args, viewmodel) === false) {
            return false;
          }
        }
      });
    },

    savecheck: function (args, viewmodel) {
      // 将账号中的@符号以后的数据补充上
      var custdata = JSON.parse(args.data.data);
      var usercode = custdata["userCode"];
      if (!usercode) return true;
      if (usercode.indexOf("@" + cb.rest.AppContext.tenant.alias) < 0) {
        custdata["userCode"] = usercode + "@" + cb.rest.AppContext.tenant.alias;
        args.data.data = JSON.stringify(custdata);
      }

      var irow;
      var jrow;
      var rangeModel = viewmodel.get("custApplyRangeInfos");
      var addressModel = viewmodel.get("custAddressInfos");

      // 检查地址
      if (rangeModel) {
        var rangeModellength = rangeModel.getRows().length;
        for (var i = 0; i < rangeModellength; i++) {
          for (var j = i + 1; j < rangeModellength; j++) {
            if (rangeModel.getCellValue(i, 'org_code') === rangeModel.getCellValue(j, 'org_code')) {
              irow = i + 1;
              jrow = j + 1;
              cb.utils.alert("适配范围：第" + irow + "行[" + rangeModel.getColumn("org").cShowCaption + "]与第" + jrow + "行重复，请检查后重试！");
              return false;
            }
          }
        }
      }
      // 检查地址
      if (rangeModel) {
        var addressModellength = addressModel.getRows().length;
        for (var i = 0; i < addressModellength; i++) {
          for (var j = i + 1; j < addressModellength; j++) {
            if (addressModel.getCellValue(i, 'addressCode') === addressModel.getCellValue(j, 'addressCode')) {
              irow = i + 1;
              jrow = j + 1;
              cb.utils.alert("地址信息：第" + irow + "行[" + addressModel.getColumn("addressCode").cShowCaption + "]与第" + jrow + "行重复，请检查后重试！");
              return false;
            }
          }
        }
      }
    },
  };
  try {
    module.exports = PC_pc_customer_VM_Extend;
  } catch (error) {}
  return PC_pc_customer_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PC/PC_pc_customer_VM.Extend.js